var _defs, _rect, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew230({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 1,
    y: 1,
    width: 14,
    height: 14
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 8,
    cy: 5.39,
    r: 2.89
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9,8.09a3,3,0,0,1-1,.19,3,3,0,0,1-1-.19L5,13.5H11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew230);
export default __webpack_public_path__ + "static/media/Symbolpack_New_230.30a5decd08c09e18b1abbb1f011c736d.svg";
export { ForwardRef as ReactComponent };